<template>
  <div class="icons">
    <Hero
      class="hero"
      heading="Icons"
    />
    <TextBlock title="Custom made Icons">
      <p>
        Simplicity through an icon. These icons are
        made to make your unique selling points stand out.
      </p>
    </TextBlock>
    <PageContainer :addPadding="true">
      <IconContainer>
        <IconItem
          title="Sustainability"
          iconImage="sustainability.svg"
        />
        <IconItem
          title="Limitless"
          iconImage="limitless.svg"
        />
        <IconItem
          title="Performance"
          iconImage="performance.svg"
        />
        <IconItem
          title="Impact"
          iconImage="impact.svg"
        />
        <IconItem
          title="CO2"
          iconImage="co2.svg"
        />
        <IconItem
          title="Adapted for<br/>every device"
          iconImage="devices.svg"
        />
        <IconItem
          title="Metrics"
          iconImage="metrics.svg"
        />
        <IconItem
          title="Maximum quality"
          iconImage="quality.svg"
        />
        <IconItem
          title="Certified in all major advertising networks"
          iconImage="certified.svg"
        />
        <IconItem
          title="Minimal load-time"
          iconImage="loadtime.svg"
        />
      </IconContainer>
      <DownloadButton class="download" url="https://seenthis-brand.s3.amazonaws.com/download/seenthis-icons.zip">Download Icon Pack</DownloadButton>
      <p class="moreIcons">We also use Google's material design icons. <a href="https://fonts.google.com/icons">Available here</a></p>
      <ViLinks />
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import TextBlock from '../components/text-block.vue';
import PageContainer from '../components/page-container.vue';
import IconContainer from '../components/icon-container.vue';
import IconItem from '../components/icon-item.vue';
import DownloadButton from '../components/download-button.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Icons',
  components: {
    Hero,
    TextBlock,
    PageContainer,
    IconContainer,
    IconItem,
    DownloadButton,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .download
    max-width: 40rem
    margin: 8rem auto
    outline: 2rem solid transparent

.moreIcons
  margin: -20px 0 30px 0
  text-align: center

  a
    font-size: 2rem
    font-weight: 700

    &:hover
      text-decoration: underline
</style>
